export const modelMetadataSymbol = Symbol("modelMetadata")
export const modelUnwrappedClassSymbol = Symbol("modelUnwrappedClass")
export const runAfterModelDecoratorSymbol = Symbol("runAfterModelDecorator")
